<template>
  <tts-mode-btn class='tts-mode-btn' :ttsMode="ttsMode" @tts-mode-changed='handleTTSMode'/>
</template>

<script>
import { inject, defineComponent } from 'vue';
import { useEvent } from '../../plugins/vue-gtag';
import TtsModeBtn from './TTSModeBtn.vue';

export default defineComponent({
  components: {
    TtsModeBtn,
  },
  setup(){
    const ttsMode = inject('ttsMode');
    const changeTTSMode = inject('handleTTSMode');
    const gaTTSMode = useEvent('mode_tts');
    
    const handleTTSMode = (...args)=>{
      changeTTSMode(...args);

      gaTTSMode(ttsMode.value ? 'word' : 'sentence');
    }

    return {
      ttsMode,
      handleTTSMode
    }
  }
})
</script>